"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assertFunction = exports.assertString = exports.assertNumber = void 0;
var errors_1 = require("./errors");
function assertNumber(input, sign) {
    if (sign === void 0) { sign = "Input"; }
    if (typeof input === "number")
        return;
    else
        throw new errors_1.TypeNotValid("[" + sign + "] should be a number!");
}
exports.assertNumber = assertNumber;
function assertString(input, sign) {
    if (sign === void 0) { sign = "Input"; }
    if (typeof input === "string")
        return;
    else
        throw new errors_1.TypeNotValid("[" + sign + "] should be a string!");
}
exports.assertString = assertString;
function assertFunction(input, sign) {
    if (sign === void 0) { sign = "Input"; }
    if (typeof input === "function")
        return;
    else
        throw new errors_1.TypeNotValid("[" + sign + "] should be a function!");
}
exports.assertFunction = assertFunction;
